export const typographyStyles = {
  h1: {
    fontSize: '28px',
    fontWeight: 600,
    color: '#EFF3FF',
    lineHeight: '40px',
    fontFamily: 'Lato',
    letterSpacing: 0
  },
  h2: {
    fontSize: '28px',
    fontWeight: 600,
    color: '#EFF3FF',
    fontFamily: 'Lato',
    lineHeight: '40px',
    letterSpacing: 0
  },
  h3: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#BBD5EA',
    fontFamily: 'Montserrat',
    lineHeight: '24px',
    letterSpacing: 0
  },
  body: {
    fontSize: '16px',
    lineHeight: '26px',
    color: '#EFF3FF',
    fontFamily: 'Lato',
    fontWeight: 400,
    letterSpacing: 0
  },
  bodyBold: {
    fontSize: '16px',
    lineHeight: '26px',
    color: '#EFF3FF',
    fontFamily: 'Lato',
    fontWeight: 700,
    letterSpacing: 0
  },
  subtitle: {
    fontSize: '20px',
    lineHeight: '24px',
    color: '#BBD5EA',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    letterSpacing: 0
  },
  cta: {
    fontSize: '36px',
    fontWeight: 600,
    color: '#FFFFFF',
    fontFamily: 'Montserrat',
    lineHeight: '48px',
    letterSpacing: 0
  },
  bodyLarge: {
    fontSize: '18px',
    lineHeight: '26px',
    color: '#FFFFFF',
    fontFamily: 'Lato',
    fontWeight: 400,
    letterSpacing: 0
  }
};

export const boxStyles = {
  section: {
    maxWidth: 900
  },
  codeBox: {
    width: 395,
    borderRadius: '8px',
    border: '1px solid #334155'
  },
  codeHeader: {
    width: '100%',
    height: 46,
    padding: '10px 16px',
    borderRadius: '8px 8px 0 0',
    bgcolor: '#191F31'
  },
  codeContent: {
    width: 395,
    padding: '10px 16px',
    borderTop: '1px solid #334155',
    color: '#EFF3FFE5',
    fontSize: '16px',
    lineHeight: '26px',
    m: 0,
    whiteSpace: 'pre-wrap',
    fontFamily: 'Lato',
    fontWeight: 400,
    letterSpacing: 0
  }
};

export const iconFilters = {
  white: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(324deg) brightness(104%) contrast(100%)',
  light: 'brightness(0) saturate(100%) invert(98%) sepia(5%) saturate(458%) hue-rotate(182deg) brightness(103%) contrast(100%)',
  dark: 'brightness(0) saturate(100%) invert(8%) sepia(18%) saturate(1567%) hue-rotate(182deg) brightness(95%) contrast(98%)'
};

export const themeColors = {
  light: {
    background: '#FFFFFF',
    cardBackground: '#F5F6F8',
    text: '#000C30',
    textSecondary: '#151823',
    textTertiary: '#0D2543',
    textMuted: '#2F3444',
    textSubtle: '#CBD5E1',
    textSubheading: '#000C30',
    textHeading: '#151823',
    textBody: '#000C30',
    textBodyWhite: '#000C30',
    textBodyAlt: '#0D2543',
    emptyStateBorder: '#D3D5DC',
    headingColor: '#0D2543',
    cellText: '#0D2543',
    border: '#D3D5DC',
    borderSecondary: '#C3CAE2',
    sidebarButton: '#F5F6F8',
    sidebarButtonHover: '#F1F2F5',
    codeBackground: '#F5F6F8',
    codeText: '#000C30E5',
    videoBackground: '#F5F6F8',
    videoBorder: '#D3D5DC',
    playButton: '#D3D5DC',
    playIcon: '#000C30'
  },
  dark: {
    background: '#151823',
    cardBackground: '#191F31',
    text: '#EFF3FF',
    textSecondary: '#EFF3FF',
    textTertiary: '#EFF3FF',
    textMuted: '#A6C5DE',
    textSubtle: '#CBD5E1',
    textSubheading: '#BBD5EA',
    textHeading: '#EFF3FF',
    textBody: '#EFF3FF',
    textBodyWhite: '#FFFFFF',
    textBodyAlt: '#CBD5E1',
    emptyStateBorder: '#363C4D',
    headingColor: '#EFF3FF',
    cellText: '#EFF3FFE5',
     border: '#334155',
    borderSecondary: '#334155',
    sidebarButton: '#2F3444',
    sidebarButtonHover: '#2F3444',
    codeBackground: '#191F31',
    codeText: '#EFF3FFE5',
    videoBackground: '#1E293B',
    videoBorder: '#334155',
    playButton: '#334155',
    playIcon: '#FFFFFF'
  }
};
